import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { SnackbarOpen } from '#app/Action/SnackbarAction';
import { dispatch } from '#app/App';
import ButtonComponent from '#app/Component/ButtonComponent';
import ApiHandler from '#app/Handler/ApiHandler';
import { getRoutePathname } from '#app/Handler/RouteHandler';

type Props = {
  onClose: () => void;
  uuid: string;
};

const CancelOrderModal: React.FC<Props> = ({ onClose, uuid }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const classes = useStyles();

  const cancelOrder = () => {
    setLoading(true);
    ApiHandler.post(
      {
        route: 'api_sale_order_client_cancel',
        params: { uuid },
      },
      (response) => {
        const success = response.status === 200;
        const errorMessage = response.error?.message || "Une erreur inattendue s'est produite.";

        dispatch(
          SnackbarOpen({
            text: success ? 'Commande annulée avec succès.' : errorMessage,
            variant: success ? 'success' : 'error',
          }),
        );

        if (success) {
          navigate(getRoutePathname('client_service_order_client_litige', { uuid: response.data?.uuid as string }));
        }
        setLoading(false);
      },
    );
  };

  return (
    <Dialog open maxWidth="xl" onClose={onClose}>
      <DialogTitle className={classes.title}>Annuler la commande</DialogTitle>
      <DialogContent className={classes.content}>
        <p>Êtes-vous sure de vouloir annuler la commande ?</p>
      </DialogContent>
      <DialogActions>
        <ButtonComponent color="#5E6E82" label="Annuler" onClick={onClose} loading={loading} />
        <ButtonComponent label="Valider" onClick={cancelOrder} loading={loading} />
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles({
  title: {
    fontSize: 15,
  },
  content: {
    minWidth: '30vw',
  },
});

export default CancelOrderModal;
